import { Tab, Tabs } from '@mui/material';
import { useEffect, useState } from 'react';
import { Page } from '@components/Page';
import { TabTab } from './tabs/TabTab';
import { HistoryTab } from './tabs/HistoryTab';
import { useLocation } from 'react-router';

function Transactions() {
  const defaultTabValue = 'tab';
  const [currentTab, setCurrentTab] = useState<string>(defaultTabValue);
  const { hash } = useLocation();

  // Update current tab when location hash changes
  useEffect(() => setCurrentTab(hash.substring(1) || defaultTabValue), [hash]);

  function handleTabChange(_: unknown, value: string) {
    // Update location hash when current tab should change
    window.location.hash = value;
  }

  return (
    <Page title='My Tab'>
      <Tabs value={currentTab} onChange={handleTabChange}>
        <Tab label='Tab' value='tab' />
        <Tab label='History' value='history' />
      </Tabs>

      {currentTab === 'history' && <HistoryTab />}

      {currentTab === 'tab' && <TabTab />}
    </Page>
  );
}

export { Transactions };
